// src/components/about/TeamSection.js
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaLinkedin, FaEnvelope, FaUserTie } from 'react-icons/fa';
import Heading from '../common/Heading';
import Section from '../common/Section';

const TeamSection = ({ title = "Our Team", subtitle = "Meet the dedicated professionals behind Leotech's mission" }) => {
  const [activeTab, setActiveTab] = useState('leadership');
  
  // Team members data from company profile
  const teamMembers = {
    leadership: [
      {
        id: 1,
        name: "Ing. Alfred Mbayoh",
        role: "CEO and Co-founder",
        credentials: "B.Eng. (Hons) Mechanical and Maintenance Engineer",
        image: "/images/team/alfred-m.png",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=AM",
        email: "alfred@leotechsl.com",
        linkedin: "https://www.linkedin.com/in/alfred-mbayoh/",
      },
      {
        id: 2,
        name: "Ing. Alhassan Kuyateh",
        role: "Secretary and Co-founder",
        credentials: "B.Eng. (Hons) Mechanical and Maintenance Engineer",
        image: "/images/team/Alhassan Kuyateh-Cofounder and secretary.jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=AK",
        email: "alhassan@leotechsl.com",
        linkedin: "https://www.linkedin.com/in/alhassan-kuyateh/",
      },
      {
        id: 3,
        name: "Mr. Bailor Bah",
        role: "Director of Programmes",
        credentials: "BSc. Computer Scientist",
        image: "/images/team/bailor_bah.jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=BB",
        email: "bailor@leotechsl.com",
        linkedin: "https://www.linkedin.com/in/bailor-bah/",
      },
      {
        id: 4,
        name: "Ms. Meitima Matilda Charles",
        role: "Manager",
        credentials: "BSc. Business and Information Technology",
        image: "/images/team/meitima.jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=MC",
        email: "bailor@leotechsl.com",
        linkedin: "https://www.linkedin.com/in/bailor-bah/",
      }
    ],
    board: [
      {
        id: 2,
        name: "Mr. Joshua Kamanda",
        role: "Board Chairman",
        credentials: "Software Reliability Engineer and Entrepreneur",
        image: "/images/team/Joshua Kamanda (Board Chairman).jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=JK",
        email: "joshua@leotechsl.com",
        linkedin: "https://www.linkedin.com/in/joshua-kamanda/",
      },
      {
        id: 1,
        name: "Prof Kelleh Gbawuru-Mansaray",
        role: "Board Member",
        credentials: "Renewable Energy Expert, Academist",
        image: "/images/team/1.0 Prof. Kelleh Gbawuru-Mansaray - Dean of Engineering and Architecture - Fourah Bay College.jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=JK",
        email: "joshua@leotechsl.com",
        linkedin: "https://www.linkedin.com/in/joshua-kamanda/",
      },
      
      
      {
        id: 3,
        name: "Amara Sorie Tunkara",
        role: "Board Member",
        credentials: "Civil Engineer, WASH Expert",
        image: "/images/team/4.0. Amara Sorie Tunkara-Civil Engineer.jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=JK",
        email: "joshua@leotechsl.com",
        linkedin: "https://www.linkedin.com/in/joshua-kamanda/",
      },
      {
        id: 4,
        name: "Mr. Sahr T. Nyalloma",
        role: "Board Member",
        credentials: "Mechanical Engineer, Academist",
        image: "/images/team/3.0. Mr Sahr Tamba Nyalloma - Senior Lecturer Mecchanical and Maintenance Engineering Department FOurah Bay College .jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=JK",
        email: "joshua@leotechsl.com",
        linkedin: "https://www.linkedin.com/in/joshua-kamanda/",
      },
      {
        id: 5,
        name: "Dr. Samba Sesay",
        role: "Board Member",
        credentials: "Electrical and Electronics Engineer",
        image: "/images/team/2.0. Dr Samba Sesay - Head of Electrical and Electronics Engineering Depsrtment - Fourah Bay College.jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=JK",
        email: "joshua@leotechsl.com",
        linkedin: "https://www.linkedin.com/in/joshua-kamanda/",
      },
    ],
    volunteers: [
      {
        id: 1,
        name: "Aminata Ngaujah",
        role: "Tutor",
        credentials: "Civil Engineer",
        image: "/images/team/aminata_ngaujah.jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=AN",
        email: "aminata.ngaujah@leotechsl.com ",
        linkedin: "https://www.linkedin.com/in/aminata-ngaujah/",
      },
      {
        id: 2,
        name: "Lansana Farroh",
        role: "Tutor",
        credentials: "Civil Engineer",
        image: "/images/team/Lansana Farroh.jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=LF",
        email: "lansana.farroh@leotechsl.com ",
        linkedin: "https://www.linkedin.com/in/aminata-ngaujah/",
      },
      {
        id: 3,
        name: "Mohamed Sylvanus Kamara",
        role: "Tutor",
        credentials: "Civil Engineer",
        image: "/images/team/Sylvanus Kamara.jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=MSK",
        email: "mohamed.kamara@leotechsl.com ",
        linkedin: "https://www.linkedin.com/in/mohamed-sylvanus-kamara/",
      },
      {
        id: 4,
        name: "Tam Tam Dauda",
        role: "Tutor",
        credentials: "Electrical and Electronics Engineer",
        image: "/images/team/Tam Tam Dauda.jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=TTD",
        email: "tamtam.dauda@leotechsl.com ",
        linkedin: "https://www.linkedin.com/in/tam-tam-dauda/",
      },
      {
        id: 5,
        name: "Samuel Casangnell",
        role: "Tutor",
        credentials: "Aspiring Software Engineer",
        image: "/images/team/samuel_casangnell.jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=SC",
        email: "samuel.casangnell@leotechsl.com",
        linkedin: "https://www.linkedin.com/in/samuel-abu-turay/",
      },
      {
        id: 6,
        name: "Samuel Tortor Koroma",
        role: "Tutor",
        credentials: "Civil Engineer",
        image: "/images/team/samuel_koroma.jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=STK",
        email: "samuel.koroma@leotechsl.com",
        linkedin: "https://www.linkedin.com/in/samuel-abu-turay/",
      },
      {
        id: 7,
        name: "Monica Musa",
        role: "Tutor",
        credentials: "Civil Engineer",
        image: "/images/team/monica_musa.jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=MM",
        email: "monica.musa@leotechsl.com ",
        linkedin: "https://www.linkedin.com/in/monica-musa/",
      },
      
      {
        id: 9,
        name: "Samuel Abu Turay",
        role: "Tutor",
        credentials: "Electrical and Electronic Engineer",
        image: "/images/team/samuel_turay.jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=SAT",
        email: "samuel.turay@leotechsl.com",
        linkedin: "https://www.linkedin.com/in/samuel-abu-turay/",
      },

      {
        id: 10,
        name: "Simeon Sahied Sesay ",
        role: "Tutor",
        credentials: "Electrical and Electronic Engineer",
        image: "/images/team/sss.jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=SSS",
        email: "samuel.sesay@leotechsl.com ",
        linkedin: "https://www.linkedin.com/in/samuel-abu-turay/",
      },
      {
        id: 11,
        name: "Sallieu Kamara",
        role: "Tutor",
        credentials: "Electrical and Electronic Engineer",
        image: "/images/team/sk.jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=SK",
        email: "sallieu.kamara@leotechsl.com",
        linkedin: "https://www.linkedin.com/in/samuel-abu-turay/",
      },
      {
        id: 12,
        name: "Mohamed Fornah",
        role: "Tutor",
        credentials: "MSc. Transportation Engineering",
        image: "/images/team/mft.jpg",
        fallbackImage: "https://placehold.co/300x300/1a237e/ffffff?text=MF",
        email: "mohamed.fornah@leotechsl.com",
        linkedin: "https://www.linkedin.com/in/samuel-abu-turay/",
      },
      
     
      
    ]
  };
  
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };
  
  // TeamMember Card component
  const TeamMemberCard = ({ member, featured = false }) => {
    const [isHovered, setIsHovered] = useState(false);
    
    return (
      <motion.div
        className={`bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 ${
          featured ? 'md:col-span-2 lg:col-span-1' : ''
        } ${isHovered ? 'scale-105' : ''}`}
        variants={itemVariants}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="flex flex-col md:flex-row">
          <div className={`${featured ? 'md:w-1/2 lg:w-full' : ''}`}>
            <div className="relative overflow-hidden h-60 bg-gray-200">
              <img
                src={member.image}
                alt={member.name}
                className="w-full h-full object-cover transition-transform duration-500 transform hover:scale-110"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = member.fallbackImage;
                }}
              />
              {/* Overlay with social links */}
              <div className={`absolute inset-0 bg-gradient-to-t from-primary-dark to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4`}>
                <div className="flex space-x-2 mb-2">
                  {member.linkedin && (
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-white text-primary p-2 rounded-full hover:bg-primary hover:text-white transition-colors"
                      aria-label={`${member.name}'s LinkedIn profile`}
                    >
                      <FaLinkedin />
                    </a>
                  )}
                  {member.email && (
                    <a
                      href={`mailto:${member.email}`}
                      className="bg-white text-primary p-2 rounded-full hover:bg-primary hover:text-white transition-colors"
                      aria-label={`Email ${member.name}`}
                    >
                      <FaEnvelope />
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
          
          <div className={`p-6 ${featured ? 'md:w-1/2 lg:w-full' : ''}`}>
            <h3 className="text-xl font-bold text-primary-dark mb-2">{member.name}</h3>
            
            <div className="text-secondary font-medium mt-1">{member.role}</div>
            
            <div className="text-sm text-gray-600 mt-1 mb-3">{member.credentials}</div>
            
            {/* LinkedIn Profile Link */}
            {member.linkedin && (
              <a
                href={member.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-primary hover:text-primary-dark transition-colors"
              >
                <FaLinkedin className="mr-2" />
                <span>LinkedIn Profile</span>
              </a>
            )}
          </div>
        </div>
      </motion.div>
    );
  };
  
  return (
    <Section background="white" padding="lg">
      <div className="text-center mb-12">
        <Heading level={2} align="center" className="mb-4" withAccent>
          {title}
        </Heading>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          {subtitle}
        </p>
      </div>
      
      {/* Tabs for team categories */}
      <div className="flex flex-wrap justify-center mb-12 border-b border-gray-200">
        <button
          className={`px-6 py-3 text-lg font-medium transition-colors ${
            activeTab === 'leadership' 
              ? 'text-primary border-b-2 border-primary' 
              : 'text-gray-600 hover:text-primary'
          }`}
          onClick={() => setActiveTab('leadership')}
        >
          Leadership Team
        </button>
        <button
          className={`px-6 py-3 text-lg font-medium transition-colors ${
            activeTab === 'board' 
              ? 'text-primary border-b-2 border-primary' 
              : 'text-gray-600 hover:text-primary'
          }`}
          onClick={() => setActiveTab('board')}
        >
          Board of Trustees
        </button>
        <button
          className={`px-6 py-3 text-lg font-medium transition-colors ${
            activeTab === 'volunteers' 
              ? 'text-primary border-b-2 border-primary' 
              : 'text-gray-600 hover:text-primary'
          }`}
          onClick={() => setActiveTab('volunteers')}
        >
          Tutors & Volunteers
        </button>
      </div>
      
      {/* Team members grid based on active tab */}
      <motion.div
        className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-${activeTab === 'board' ? '1' : '3'} gap-8`}
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        key={activeTab} // This forces re-render of animation when tab changes
      >
        {teamMembers[activeTab].map((member) => (
          <TeamMemberCard 
            key={member.id} 
            member={member} 
            featured={activeTab === 'board'}
          />
        ))}
      </motion.div>
      
      {/* When board tab is active, show organizational structure */}
      {activeTab === 'board' && (
        <div className="mt-16">
          <div className="text-center mb-8">
            <Heading level={3} align="center">
              Organizational Structure
            </Heading>
            <p className="text-gray-600 mt-4">
              Leotech operates with a clear organizational structure that ensures effective governance and operational excellence
            </p>
          </div>
          
          <div className="bg-white rounded-xl shadow-lg p-8 max-w-3xl mx-auto">
            <div className="flex flex-col items-center">
              <div className="bg-primary-dark text-white rounded-lg p-4 w-48 text-center mb-4">
                <div className="font-bold">Board of Trustees</div>
              </div>
              <div className="w-1 h-8 bg-gray-300"></div>
              <div className="bg-primary text-white rounded-lg p-4 w-48 text-center mb-4">
                <div className="font-bold">Chief Executive Officer</div>
              </div>
              <div className="w-1 h-8 bg-gray-300"></div>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                <div className="bg-blue-100 text-primary-dark rounded-lg p-4 text-center">
                  <div className="font-bold">Director</div>
                </div>
                <div className="bg-blue-100 text-primary-dark rounded-lg p-4 text-center">
                  <div className="font-bold">Secretary</div>
                </div>
                <div className="bg-blue-100 text-primary-dark rounded-lg p-4 text-center">
                  <div className="font-bold">Manager</div>
                </div>
              </div>
              
              <div className="w-full h-8 flex justify-center items-center">
                <div className="w-3/4 h-1 bg-gray-300"></div>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 w-full">
                <div className="bg-gray-100 text-gray-800 rounded-lg p-3 text-center text-sm">
                  <div className="font-medium">BIM & Civil</div>
                </div>
                <div className="bg-gray-100 text-gray-800 rounded-lg p-3 text-center text-sm">
                  <div className="font-medium">Innovation</div>
                </div>
                <div className="bg-gray-100 text-gray-800 rounded-lg p-3 text-center text-sm">
                  <div className="font-medium">UAV/Drones</div>
                </div>
                <div className="bg-gray-100 text-gray-800 rounded-lg p-3 text-center text-sm">
                  <div className="font-medium">ICT</div>
                </div>
              </div>
              
              <div className="w-full h-8 flex justify-center items-center">
                <div className="w-3/4 h-1 bg-gray-300"></div>
              </div>
              
              <div className="bg-secondary text-white rounded-lg p-4 w-64 text-center">
                <div className="font-bold">Staff/Tutors/Volunteers</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Section>
  );
};

export default TeamSection;